import { render, staticRenderFns } from "./PanelHeader.vue?vue&type=template&id=13192ac7"
import script from "./PanelHeader.vue?vue&type=script&lang=js"
export * from "./PanelHeader.vue?vue&type=script&lang=js"
import style0 from "./PanelHeader.vue?vue&type=style&index=0&id=13192ac7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports